export function VerificationMark({ label }: { label: string }) {
  return (
    <span className="verification-mark">
      <span className="verification-mark__lines" aria-hidden="true">
        <i /><i /><i />
      </span>
      <span>{label}</span>
    </span>
  )
}
